import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  margin-bottom: 24px;
  display: flex;
  align-items: stretch;
  > div {
    margin: 0 4px 0 0;
  }
  > div + div {
    margin: 0 0 0 4px;
  }
`

interface IOptionProps {
  selected: boolean
}

export const Option = styled.div<IOptionProps>`
  width: 100%;
  padding: 8px;
  border-radius: 10px;
  border: 2px solid #d9d9d9;
  cursor: pointer;
  transition: 200ms;
  .ant-radio-wrapper {
    position: absolute;
  }
  ${(props) =>
    props.selected &&
    css`
      border: 2px solid #2684ff !important;
      .ant-radio-inner {
        border-color: #2684ff !important;
      }
    `}
  &:hover {
    border: 2px solid #c4c0c0;
    .ant-radio-inner {
      border-color: #9ecffa;
    }
  }
`

export const Description = styled.div`
  padding-left: 23px;
`

export const Title = styled.div`
  color: #262626;
  font-weight: bold;
`

export const Subtitle = styled.div`
  color: #262626;
  font-size: 12px;
`
